import { dateValidation } from '../../components/UploadDocuments/AddATenant/utils/dateValidation';
import { IGuest } from '../ts/user';

type IGuestKey = keyof IGuest;
export const tenantsFieldAreValid = (guests: IGuest[]) => {
  const requiredFields: IGuestKey[] = [
    'user_first_name',
    'user_last_name',
    'user_occupation',
    'user_email',
    'user_phone_no',
    'user_place_of_birth',
    'user_birth',
    'user_id_document_number',
    'user_id_document_type',
    'user_id_document_expiry_date',
    'user_monthly_income',
  ];
  return guests.every((guest: IGuest) => {
    return requiredFields.every(key => {
      if (key === 'user_id_document_expiry_date' || key === 'user_birth') {
        return dateValidation(guest[key] ?? '');
      }
      return guest[key];
    });
  });
};
